import React from 'react'
import { DeleteInvoiceSettings } from './DeleteInvoiceSettings';
import { FormInvoiceSettings } from './FormInvoiceSettings';
import { Dialog } from 'primereact/dialog';
import { Button} from 'reactstrap';

export const ModalInvoiceSettings = (props) => {

    const {
        modal, modalTitle, method, toggle, loading,
        id_type_document, code, serie, initial_folio, final_folio, is_default, is_fiscal, validationInvoiceSettings,
        listTypeDocuments,
        handleInputChange, saveCreate, saveUpdate, saveDelete, closeDialog
    } = props;

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>
            <Button
                color="primary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
            >
                Confirmar
            </Button>
        </div>
    );
    

    return (
        <Dialog  header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
             footer={footer}>
            {
                (method === "create" || method === "update")
                ?
                    <FormInvoiceSettings
                        button={method === "create" ? "Guardar" : "Actualizar"}
                        {
                            ...{
                                closeDialog, loading, 
                                id_type_document, code, serie, initial_folio, final_folio, is_default, is_fiscal, validationInvoiceSettings,
                                listTypeDocuments, 
                                handleInputChange, 
                                methodAction : (method === "create" ? saveCreate : saveUpdate)
                            }
                        }
                    />
                : 
                   null
            }
        </Dialog>
    )
}
